import './search-recap.scss';

/**
 * version    1.0
 * class      <type> (SearchRecap)
 * classdesc   SearchRecap
 */
export class SearchRecap {}
